import React, { useContext, useState } from 'react';
import { STYLES } from '../../consts';
import { FormItemWrapper } from './FormItemWrapper';
import { BillAmount } from './BillAmount';
import { BillNumber } from './BillNumber';
import { DueDate } from './DueDate';
import { BillAttachment } from './BillAttachment';
import { BillVendor } from './BillVendor';
import { CreationCtx } from '../../pages';
import { PaymentReminder } from './PaymentReminder';

interface FormWrapperItem {
    component: React.ReactNode;
    shouldDisableBlockStyles?: boolean;
}

export const FormWrapper = () => {
  const [formItems] = useState<FormWrapperItem[]>([
    {
      component: <BillVendor />,
    }, {
      component: <BillAmount />,
    }, {
      component: <DueDate />,
    }, {
      component: <BillNumber />,
    }, {
      component: <PaymentReminder />,
      shouldDisableBlockStyles: true,
    },
  ]);
  const ctx = useContext(CreationCtx);
  return (
    <div className={STYLES.CREATE_BILL_BODY.FORM_WRAPPER}>
      <div className={STYLES.CREATE_BILL_BODY.FLOATING_SCROLLABLE_DIV}>
        {formItems.map(formItem => (
          <FormItemWrapper shouldDisableBlockStyles={formItem.shouldDisableBlockStyles}>
            {formItem.component}
          </FormItemWrapper>
        ))}
        {!ctx.isInitiatedWithBillImage && <BillAttachment />}
      </div>
    </div>
  );
};
